import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom'; // 1. Import useLocation

function Register() {
    // 2. Add referralCode to initial state
    const [form, setForm] = useState({ 
        name: '', 
        email: '', 
        phone: '', 
        password: '', 
        referralCode: '' 
    });
    
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();
    const location = useLocation(); // 3. Get access to URL params

    // 4. useEffect to grab the code from URL (e.g., yoursite.com/register?ref=VIMAL123)
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const refParam = queryParams.get('ref');
        if (refParam) {
            setForm(prev => ({ ...prev, referralCode: refParam }));
        }
    }, [location]);

    const validate = () => {
        const newErrors = {};
        if (!form.name.trim()) newErrors.name = "Name is required";
        if (!form.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(form.email)) {
            newErrors.email = "Enter a valid email";
        }
        if (!form.phone) {
            newErrors.phone = "Phone is required";
        } else if (!/^[0-9]{10}$/.test(form.phone)) {
            newErrors.phone = "Phone must be 10 digits";
        }
        if (!form.password) {
            newErrors.password = "Password is required";
        } else if (form.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }
        return newErrors;
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});
        setLoading(true);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/api/auth/register`,
                form, // This now contains name, email, phone, password AND referralCode
                { headers: { "Content-Type": "application/json" } }
            );

            const { token, user } = res.data;

            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));

            // Optional: Customize alert if points were earned
            if (user.points > 0) {
                alert(`✅ Registered successfully! You earned ${user.points} bonus points.`);
            } else {
                alert('✅ Registered successfully!');
            }
            
            navigate('/profile'); 

        } catch (err) {
            alert(err.response?.data?.msg || '❌ Registration failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100 bg-light">
            <div className="card shadow p-4" style={{ maxWidth: '400px', width: '100%' }}>
                <h3 className="text-center mb-4">Register</h3>
                <form onSubmit={handleRegister} noValidate>
                    {/* Name */}
                    <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                            type="text"
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            placeholder="Enter name"
                            value={form.name}
                            onChange={e => setForm({ ...form, name: e.target.value })}
                        />
                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>

                    {/* Email */}
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            placeholder="Enter email"
                            value={form.email}
                            onChange={e => setForm({ ...form, email: e.target.value })}
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>

                    {/* Phone */}
                    <div className="mb-3">
                        <label className="form-label">Phone</label>
                        <input
                            type="text"
                            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                            placeholder="Enter phone"
                            value={form.phone}
                            onChange={e => setForm({ ...form, phone: e.target.value })}
                        />
                        {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                    </div>

                    {/* Password */}
                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input
                            type="password"
                            className={`form-control ${errors.password ? "is-invalid" : ""}`}
                            placeholder="Enter password"
                            value={form.password}
                            onChange={e => setForm({ ...form, password: e.target.value })}
                        />
                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    </div>

                    {/* NEW FIELD: Referral Code */}
                    <div className="mb-3">
                        <label className="form-label">Referral Code (Optional)</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="e.g. VIMAL123"
                            value={form.referralCode}
                            onChange={e => setForm({ ...form, referralCode: e.target.value })}
                        />
                        <div className="form-text text-muted">
                            Have a referral code? Enter it to earn bonus points.
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="btn btn-success w-100"
                        disabled={loading}
                    >
                        {loading ? "Registering..." : "Register"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Register;